<template>
  <material-card
      :title="title"
      :color="$vuetify.theme.themes.light.secondary"
      icon="flag"
    >
    <v-card-text v-if="memberFlags && flags">
      <v-container fluid fill-height>
        <v-flex md12>
          <v-form ref="form">
            <trans-multi-select2
              v-model="memberFlags"
              :items="flags"
              :label="$t('components.flagmemberdialog.flag')"
              field="Name"
              itemValue="Id"
            ></trans-multi-select2>
          </v-form>
        </v-flex>
      </v-container>
    </v-card-text>
    <v-container fluid grid-list-md v-else>
      <v-layout row justify-center>
        <v-flex xs12 sm6 md4 lg3>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-btn :disabled="saving" color="" text @click="$emit('close')">{{
        $t("globals.cancel")
      }}</v-btn>
      <v-btn :disabled="!memberFlags || !flags" :loading="saving" color="primary" @click="flag">{{
        $t("components.flagmemberdialog.flag")
      }}</v-btn>
    </v-card-actions>
  </material-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TransMultiSelect2 from "../components/TransMultiSelect2";
export default {
  name: "member-flags-form",
  props: ["memberId", "title"],
  components: { TransMultiSelect2 },
  data() {
    return {
      saving: false,
      flags: null,
      memberFlags: null,
    };
  },
  methods: {
    async flag() {
      this.saving = true;
      try {
        await this.saveMemberFlags({
          planIdentityId: this.selectedPlan.Id,
          flags: this.memberFlags.map((f) => f.Id),
          memberId: this.memberId,
        });
        this.$emit("save");
      } catch (e) {
        console.error(e);
      }
      this.saving = false;
    },
    async loadData() {
      this.memberFlags = null;
      this.flags = null;
      this.memberFlags = (await this.getMemberFlags({
        planIdentityId: this.selectedPlan.Id,
        memberId: this.memberId,
      })).data.Flags;
      this.flags = (await this.getPlanFlags({
        planIdentityId: this.selectedPlan.Id,
        memberId: this.memberId,
      })).data.Flags;
    },
    ...mapActions("plansMembers", [
      "getMemberFlags",
      "getPlanFlags",
      "saveMemberFlags",
    ]),
  },
  mounted() {},
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  watch: {
    memberId: {
      immediate: true,
      handler() {
        this.loadData();
      },
    },
  },
};
</script>
